import type { BlogLocale } from './types';

export type BlogCategoryFilterId =
  | 'all'
  | 'profit-analytics'
  | 'shopify-kpis'
  | 'ads-reporting'
  | 'attribution'
  | 'inventory'
  | 'ai-analytics';

/**
 * Valori `BlogPost.category` ammessi per il filtro (stringa canonica EN).
 * Allineare i post del manifest a questi label.
 */
const CATEGORY_ALIASES: Record<
  Exclude<BlogCategoryFilterId, 'all'>,
  readonly string[]
> = {
  'profit-analytics': ['Profit Analytics'],
  'shopify-kpis': ['Shopify KPIs', 'Shopify Analytics'],
  'ads-reporting': ['Ads Reporting'],
  attribution: ['Attribution'],
  inventory: ['Inventory'],
  'ai-analytics': ['AI Analytics'],
};

export const BLOG_CATEGORY_ORDER: BlogCategoryFilterId[] = [
  'all',
  'profit-analytics',
  'shopify-kpis',
  'ads-reporting',
  'attribution',
  'inventory',
  'ai-analytics',
];

export function getBlogCategoryLabel(
  id: BlogCategoryFilterId,
  locale: BlogLocale,
): string {
  if (locale === 'it') {
    const it: Record<BlogCategoryFilterId, string> = {
      all: 'Tutti',
      'profit-analytics': 'Profit analytics',
      'shopify-kpis': 'KPI Shopify',
      'ads-reporting': 'Reportistica ads',
      attribution: 'Attribuzione',
      inventory: 'Inventario',
      'ai-analytics': 'AI analytics',
    };
    return it[id];
  }
  const en: Record<BlogCategoryFilterId, string> = {
    all: 'All',
    'profit-analytics': 'Profit Analytics',
    'shopify-kpis': 'Shopify KPIs',
    'ads-reporting': 'Ads Reporting',
    attribution: 'Attribution',
    inventory: 'Inventory',
    'ai-analytics': 'AI Analytics',
  };
  return en[id];
}

export function postMatchesBlogCategory(
  postCategory: string,
  filterId: BlogCategoryFilterId,
): boolean {
  if (filterId === 'all') return true;
  const aliases = CATEGORY_ALIASES[filterId];
  return aliases.includes(postCategory.trim());
}
